import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../api/client';

export interface PaymentsState {
  paymentMethods: any[];
  loading: boolean;
  error: string | null;
}

const initialState: PaymentsState = {
  paymentMethods: [],
  loading: false,
  error: null,
};

export const fetchPaymentMethods = createAsyncThunk(
  'payments/fetchPaymentMethods',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.payments.list();
      if (res.success && res.data) {
        return res.data;
      }
      return rejectWithValue(res.message || 'Failed to fetch payment methods');
    } catch (err: any) {
      return rejectWithValue(err.message || 'Failed to fetch payment methods');
    }
  }
);

const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentMethods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentMethods = action.payload;
      })
      .addCase(fetchPaymentMethods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default paymentsSlice.reducer;
